<template>
  <div
    v-if="notification"
    class="notificationItem"
    :class="{unread: !notification.is_read}"
    @click="handleCTA(notification)"
  >
    <div class="icon">
      <el-image
        v-if="notification.type === 'calendar'"
        :src="require('@/assets/icon/notificationCalendar.png')"
        :fit="'cover'"
      />
      <el-image
        v-else-if="notification.type === 'assessment'"
        :src="require('@/assets/icon/notificationAssessments.png')"
        :fit="'cover'"
      />
      <el-image
        v-else
        :src="require('@/assets/icon/notificationGeneral.png')"
        :fit="'cover'"
      />
    </div>
    <div class="content">
      <div class="title">
        {{ notification.title }}
      </div>
      <div class="message">
        {{ notification.description }}
      </div>
    </div>
    <div class="action">
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('notification.markAsRead')"
        placement="left"
        @click.stop="markAsRead({id: notification.uuid})"
      >
        <el-button
          circle
          @click.stop="markAsRead({id: notification.uuid})"
        >
          <img
            src="@/assets/icon/MarkAsRead.png"
            alt="Mark as read"
          />
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    notification: {
      type: Object,
      default: null,
    },
  },

  methods: {
    ...mapActions('notifications', [
      'markAsRead',
    ]),

    handleCTA(notification) {
      this.$emit('click');
      this.markAsRead({ id: notification.uuid });

      if (notification.cta) {
        // Exemple
        // route:myLeader|params:param1=111111,param2=222222,….|query:query1=1111,query2=22222…

        const cta = notification.cta.split('|');
        if (cta[0].startsWith('route')) {
          const name = cta[0].split(':')[1];
          const params = {};
          const query = {};

          cta.slice(1).forEach((el) => {
            if (el.startsWith('params')) {
              const param = el.split(':')[1].split(',');
              param.forEach((p) => {
                const tmp = p.split('=');
                const [paramName, paramValue] = tmp;
                params[paramName] = paramValue;
              });
            }

            if (el.startsWith('query')) {
              const param = el.split(':')[1].split(',');
              param.forEach((p) => {
                const tmp = p.split('=');
                const [paramName, paramValue] = tmp;
                query[paramName] = paramValue;
              });
            }
          });

          this.$router.push({ name, params, query }).catch((err) => {});
        }
      } else {
        // display description in modal
        this.$emit('showModal');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notificationItem {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 7px;
  cursor: pointer;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  display: flex;

  &.unread {
    background-color: #fff8e8;
  }

  &:hover {
    background-color: #ecf5ff;
  }

  .icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .content {
    display: inline-block;
    line-height: 20px;
    margin-left: 20px;
    width: calc(100% - 100px);

    .title {
      font-size: 14px;
      word-break: break-word;
    }

    .message {
      font-size: 12px;
    }
  }

  .action {
    float: right;
    text-align: center;

    .el-button {
      background-color: transparent;
      border-width: 0;
    }
  }
}
</style>

<style lang="scss">
.notificationItem {
  .icon {
    .el-image__inner.el-image__inner--center {
      transform: none;
      left: 0;
    }
  }
}
</style>
